export default "__VITE_ASSET__BfplbzwM__"